"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptService = void 0;
class ScriptService {
    constructor() {
        this.timeoutDefault = 20000;
    }
    Load(key, baseUrl, callbackName, apiObjectName, timeout = this.timeoutDefault, errorCallback = () => null) {
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                reject(new Error('Script loading canceled by timeout'));
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                window[callbackName] = () => undefined;
            }, timeout);
            window[callbackName] = () => {
                if (timeoutId !== null) {
                    clearTimeout(timeoutId);
                }
                resolve(window[apiObjectName]);
                delete window[callbackName];
            };
            const scriptElement = document.createElement('script');
            scriptElement.src = `${baseUrl}${key}&callback=${callbackName}`;
            scriptElement.onerror = errorCallback;
            document.body.appendChild(scriptElement);
        });
    }
    LoadBasic(uri) {
        return new Promise(resolve => {
            const tag = document.createElement('script');
            tag.src = uri;
            tag.async = true;
            tag.onload = () => {
                resolve();
            };
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });
    }
}
const service = new ScriptService();
exports.ScriptService = service;
